import { render, staticRenderFns } from "./NewWorkDay.vue?vue&type=template&id=76845c56&scoped=true"
import script from "./NewWorkDay.vue?vue&type=script&lang=js"
export * from "./NewWorkDay.vue?vue&type=script&lang=js"
import style0 from "./NewWorkDay.vue?vue&type=style&index=0&id=76845c56&prod&lang=scss&scoped=true"
import style1 from "./NewWorkDay.vue?vue&type=style&index=1&id=76845c56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76845c56",
  null
  
)

export default component.exports